<template>
  <div class="info-page">
    <crumbs title="案例管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="100px"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>案例详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="案例名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入案例名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="行业应用" prop="industryUseId">
              <enumerate
                v-model="form.industryUseId"
                url="/api/solutioncenter/industryusetypeenum"
                placeholder="请选择行业应用"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应用场景" prop="useScenceId">
              <enumerate
                v-model="form.useScenceId"
                url="/api/solutioncenter/usescenetypeenum"
                placeholder="请选择应用场景"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="案例介绍" prop="description">
              <el-input
                v-model="form.description"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入案例介绍"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="图片或视频" prop="isPic" required>
              <el-switch v-model="form.isPic"> </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="form.isPic">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="图片" prop="imgUploadList">
                <image-upload
                  url="/api/achievement/uploadachiattach"
                  accept="image/jpeg,image/png,image/bmp,image/webp"
                  :file-list.sync="form.imgUploadList"
                  :num-limit="1"
                  :size-limit="10"
                  :multiple="false"
                >
                  <template>
                    <el-alert
                      :title="`上传图片格式要求 jpg、jpeg、webp、bmp、png；图片建议比例为16：9；大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                      type="warning"
                    >
                    </el-alert>
                  </template>
                </image-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="视频" prop="videoList">
                <video-upload
                  url="/api/video/uploadingstream"
                  :file-list.sync="form.videoList"
                  text="上传视频"
                  :validate-event="false"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="附件上传" prop="fileUploadList">
              <file-upload
                url="/api/Achievement/UploadAchiAttach"
                :file-list.sync="form.fileUploadList"
                accept="text/plain,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :num-limit="5"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "typicalCaseInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        // 详细信息
        name: "",
        industryUseId: "", // integer
        useScenceId: "", // integer
        description: "",
        isPic: true,
        imgUploadList: [], // imageList 相对应
        videoList: [], // videoList 相对应
        fileUploadList: [] // attachList 相对应
      },
      rules: {
        name: [isEmpty("请输入案例名称")],
        industryUseId: [isEmpty("请选择行业应用", "change")],
        useScenceId: [isEmpty("请选择应用场景", "change")],
        imgUploadList: [isEmpty("请上传图片", "change")],
        videoList: [isEmpty("请上传视频", "change")],
        description: [isEmpty("请输入案例介绍")]
      }
    };
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // integer
        industryUseId,
        useScenceId,
        // list
        imgUploadList,
        videoList,
        fileUploadList,
        ...others
      } = this.form;
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0] : file;
      };
      const turnFile = {
        imageList: imgUploadList,
        videoList: videoList,
        attachList: fileUploadList
      };
      Object.keys(turnFile).map((key) => {
        turnFile[key] = turnFile[key].map((item) => {
          return deconstruct(item);
        });
      });
      // 处理字符串 转为数字
      const turnNumber = {
        industryUseId,
        useScenceId
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === "" ? -1 : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        ...turnFile
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // -1 => ""
        industryUseId,
        useScenceId,
        // list
        imageList,
        videoList,
        attachList,
        ...others
      } = data;
      // 处理文件
      const turnFile = {
        imgUploadList: imageList,
        videoList: videoList,
        fileUploadList: attachList
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] = file === "" ? [] : file;
      });
      // 处理数字 转为字符串
      const turnNumber = {
        industryUseId,
        useScenceId
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === -1 ? "" : turnNumber[key];
      });

      return {
        ...others,
        ...turnNumber,
        ...turnFile
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("typicalCase", "addCase", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("typicalCase", "modifyCase", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("typicalCase", "getCaseInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          // this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/dataManage/typicalCaseList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
